import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#007BC1',
    },
    secondary: {
      main: '#53555F',
    },
    active: {
      main: '#FFCC00',
    },
  },
});

export default theme;
